import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (!_ctx.link)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: _normalizeClass(_ctx.mode)
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 2))
    : (_openBlock(), _createBlock(_component_router_link, {
        key: 1,
        to: _ctx.to,
        class: _normalizeClass(_ctx.mode)
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _: 3
      }, 8, ["to", "class"]))
}